// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2QzzV","inputWrap":"CustomTip_inputWrap__3sLNx"};